export class EstructuraFisica {
  id: number;
  /**
   * Id principal de la tabla
   */
  idEstructuraFisica: string;
  /**
   * Código
   */
  codigo: string;
  /**
   * Nombre de la estructura física
   */
  estructuraFisica: string;
  /**
   * Id de la clasificación de la sede
   */
  idClasificacionSede: string;
  /**
   * Nombre de la clasificación de la sede
   */
  clasificacionSede: string;
  /**
   * Id de la localización
   */
  idLocalizacion: string;
  /**
   * Dirección
   */
  direccion: string;
  /**
   * Camino
   */
  camino: string;
  /**
   * Telefono
   */
  telefono: number;
  /**
   * Celular
   */
  celular: string;
  /**
   * Correo electrónico
   */
  correoElectronico: string;
  /**
   * Número de zonas
   */
  numeroZonas: number;
  /**
   * IndicadorVirtual
   */
  indicadorVirtual: boolean;
  /**
   * Indicador habilitado
   */
  indicadorHabilitado = true;
  /**
   * Indicador requiere
   */
  indicadorRequiere = false;
    /**
   * Indicador tipo aprobacion
   */
  indicadorRestriccionAprobacion = false;
  /**
   * Usuario que hizo la ultima actualización
   */
  auditoriaUsuario: string;
  /**
   * Fecha de la ultima actualización
   */
  auditoriaFecha: Date;
  /**
   * Categoria
   */
  categoria: string;
  /**
   * Número zonas
   */
  nroZonas: number;
  auditoriaUsuarioSistema: string;

  /**
   * Constructor de la clase
   */
  constructor(){ }
}
